<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.keyword"
              @keyup.enter="clickQuery"
              type="search"
              :placeholder="
                $l('Number_ChineseName_search') || '编号/中文名称搜索...'
              "
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="clickQuery">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="visible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="130px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_scm_type') || '厂商类型'">
              <el-checkbox-group v-model="form.scmTypeList">
                <el-checkbox label="A">{{
                  $l('form_label_scm_type_a') || '业务类'
                }}</el-checkbox>
                <el-checkbox label="B">{{
                  $l('form_label_scm_type_b') || '行政类'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_scm_mode') || '合作模式'">
              <el-checkbox-group v-model="form.scmModeList">
                <el-checkbox label="A">{{
                  $l('form_label_scm_mode_a') || '海选'
                }}</el-checkbox>
                <el-checkbox label="B">{{
                  $l('form_label_scm_mode_b') || '潜在'
                }}</el-checkbox>
                <el-checkbox label="C">{{
                  $l('form_label_scm_mode_c') || '正式'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12"
            ><el-form-item
              :label="$l('form_label_supplier_name_cn') || '供应商名称'"
            >
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.scmName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_supplier_category') || '厂商类别'"
            >
              <el-select
                size="small"
                v-model="form.scmCategoryCodeList"
                style="width: 100%"
                filterable
                multiple
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_factory_inspection') || '工厂资质'"
              prop="factoryInspectionArray"
            >
              <el-select
                v-model="form.factoryInspectionArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in factoryInspectionOptions"
                  :key="item.code"
                  :label="item.label"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_certificate_info') || '相关证书'"
              prop="certificateInfoArray"
            >
              <el-select
                v-model="form.certificateInfoArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in certificateInfoOptions"
                  :key="item.code"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_customer') || '适用客户'"
              prop="suitableForCustomersArray"
            >
              <el-select
                v-model="form.suitableForCustomersArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in suitableForCustomersOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_main_categories') || '产品主要品类'"
            >
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.scmProductCategory"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_area') || '省市区县'"
                prop="provinceCode"
              >
                <el-col :span="8">
                  <el-select
                    size="small"
                    v-model="form.provinceCode"
                    :placeholder="
                      $l('INDEX.tips_select_placeholder') || '请选择'
                    "
                    style="width:100%;"
                    @change="loadCityOptions"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    size="small"
                    v-model="form.cityCode"
                    @change="loadDistrictOptions"
                    :placeholder="
                      $l('INDEX.tips_select_placeholder') || '请选择'
                    "
                    style="width:100%;"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    size="small"
                    v-model="form.districtCode"
                    :placeholder="
                      $l('INDEX.tips_select_placeholder') || '请选择'
                    "
                    style="width:100%;"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in districtOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_supply_detailed_address') || '详细地址'"
            >
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.scmAddress"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-form-item :label="$l('Whether_cooperation') || '是否合作'">
            <el-col :span="24">
              <el-checkbox-group v-model="form.isCooperationList">
                <el-checkbox label="Y">{{
                  $l('form_label_have_cooperation') || '已合作'
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l('form_label_no_cooperation') || '未合作'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="onReset">{{
          $l('INDEX.btn_reset_filter ') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="clickQuery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      provinceOptions: [], //  省份
      cityOptions: [], //  市
      districtOptions: [], //  县
      categoryOptions: [], // 供应商类别下拉
      factoryInspectionOptions: [], //工厂资质
      certificateInfoOptions: [], //证书类型
      suitableForCustomersOptions: [], //适用客户
      form: {
        keyword: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        scmName: '',
        scmTypeList: [],
        scmModeList: [],
        scmProductCategory: '',
        isCooperationList: [],
        scmStatusList: ['Y', 'P', 'B'],
        scmCategoryCodeList: [],
        certificateInfoArray: [],
        factoryInspectionArray: [],
        suitableForCustomersArray: []
      }
    }
  },

  methods: {
    closeDialog() {
      this.visible = false
    },
    clickQuery() {
      this.$emit('reset')
      this.query()
    },

    onReset() {
      this.form = {
        keyword: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        scmName: '',
        scmProductCategory: '',
        scmTypeList: [],
        scmModeList: [],
        isCooperationList: [],
        scmStatusList: ['Y', 'P', 'B'],
        scmCategoryCodeList: [],
        certificateInfoArray: [],
        factoryInspectionArray: [],
        suitableForCustomersArray: []
      }
      this.$emit('reset')
      this.query()
      this.loadCategoryData()
      this.loadProvinceOptions()
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    reset() {
      // this.$refs.form.resetFields()
      this.factoryInspectionOptions = [] //工厂资质
      this.certificateInfoOptions = [] //证书类型
      this.suitableForCustomersOptions = [] //适用客户
      this.query()
    },
    // 省份下拉
    loadProvinceOptions() {
      let regionDictParam = { levelType: '1', parentId: '0' }
      // 省份下拉
      this.$api
        .baseRegion(regionDictParam)
        .then((res) => {
          this.provinceOptions = res.body.data
          this.loadCityOptions()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 市级下拉
    loadCityOptions() {
      let regionDictParam = {
        levelType: '2',
        parentId: this.form.provinceCode
      }
      if (
        regionDictParam.parentId !== null &&
        regionDictParam.parentId !== ''
      ) {
        this.$api.baseRegion(regionDictParam).then((res) => {
          this.cityOptions = res.body.data
          // 当省级发生变化时,清空市县
          if (this.cityValid) {
            this.form.cityCode = ''
            this.form.districtCode = ''
          }
          this.loadDistrictOptions()
          this.cityValid = true
        })
      } else {
        this.form.cityCode = ''
        this.form.districtCode = ''
        this.cityOptions = []
        this.districtOptions = []
      }
    },
    // 县级下拉
    loadDistrictOptions() {
      let regionDictParam = {
        levelType: '3',
        parentId: this.form.cityCode
      }
      if (
        regionDictParam.parentId !== null &&
        regionDictParam.parentId !== ''
      ) {
        this.$api.baseRegion(regionDictParam).then((res) => {
          this.districtOptions = res.body.data
          // 当市级发生变化时,清空区县
          if (this.districtValid) {
            this.form.districtCode = ''
          }
          this.districtValid = true
        })
      } else {
        this.form.districtCode = ''
        this.districtOptions = []
      }
    },
    // 获取供应商类别下拉
    loadCategoryData() {
      this.$api
        .scmCategoryOptionApi({})
        .then((res) => {
          this.categoryOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })

      //工厂资质下拉
      this.$api
        .bizDict({ dictType: 'factoryInspectionCode' })
        .then((res) => {
          this.factoryInspectionOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })

      //证书类型下拉
      this.$api
        .bizDict({ dictType: 'certificateInfoCode' })
        .then((res) => {
          this.certificateInfoOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })

      //适用客户下拉
      this.$api
        .masterTargetCustomer_attributesSelect()
        .then((res) => {
          this.suitableForCustomersOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })
      //供应商来源下拉
      this.$api
        .bizDict({ dictType: 'scmSource' })
        .then((res) => {
          this.scmSourceOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  mounted() {
    this.onReset()
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
